'use no memo';

import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {featureFlags} from '@dms/feature-flags';

import {CustomerSelectSearchAdvanced} from './CustomerSelectSearchAdvanced';
import {CustomerSelectSearchLegacy} from './CustomerSelectSearchLegacy';
import {CustomerSelectSearchProps} from './types';

export type {
  SaneCustomer,
  SaneCustomerType,
  SanePrimaryContact,
  CustomerSelectSearchType,
} from './types';

/**
 * Customer search entry point.
 *
 * Renders the advanced customer search when the `CUSTOMER_PRIMARY_CONTACT` feature
 * flag is enabled and falls back to the original (legacy) search component when it
 * is disabled.
 */
export function CustomerSelectSearch(props: CustomerSelectSearchProps) {
  return match(isFeatureEnabled(featureFlags.CUSTOMER_PRIMARY_CONTACT))
    .with(true, () => <CustomerSelectSearchAdvanced {...props} />)
    .with(false, () => <CustomerSelectSearchLegacy {...props} />)
    .exhaustive();
}
